<template>
  <span :class="style.heading">Домен</span>
  <div :class="style.inputs">
    <InputStyle size="M" v-model="currentIp" readOnly description="IP" />
    <InputStyle
      size="M"
      description="Domain"
      placeholder="Введите domain"
      v-model="localIntegration.domain"
      @blur="onDomainBlur"
    />
  </div>
  <div :class="style.buttons">
    <PrimaryButton
      :text="edit ? 'Сохранить' : 'Добавить интеграцию'"
      @click="saveIntegration"
    />
    <SecondaryButton
      :text="'Удалить'"
      v-if="edit"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./settingIntegrations.module.scss";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";

export default defineComponent({
  name: "SettingIntegrationDomain",
  components: {InputStyle, SecondaryButton, PrimaryButton},
  emits: ["delete", "closeModal"],
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    integration: {
      type: String,
      default: ""
    },
    integrationIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      style,
      trashIcon,
      currentIp: "46.12.223.124",
      localIntegration: {
        domain: this.integration ?? ""
      }
    };
  },
  mounted() {
    if (this.integration) {
      this.localIntegration.domain = this.integration;
    }
  },
  methods: {
    saveIntegration() {
      const integration = this.getIntegration.domain;

      if (!integration) return;

      if (
        this.edit &&
        this.integrationIndex >= 0 &&
        this.integrationIndex < integration.integration.length
      ) {
        integration.integration[this.integrationIndex] =
          this.localIntegration.domain;
      } else {
        integration.integration.push(this.localIntegration.domain);
      }

      this.$emit("closeModal");
    },
    normalizeDomain(value: string): string {
      if (!value) return "";

      let domain = value.trim().toLowerCase();

      domain = domain.replace(/^https?:\/\//, "");
      domain = domain.replace(/^www\./, "");
      domain = domain.split("/")[0];

      const parts = domain.split(".");
      const tld = parts[parts.length - 1];

      const VALID_TLDS = ["ru", "com", "net", "org", "io", "dev"];

      if (!VALID_TLDS.includes(tld)) {
        domain += ".ru";
      }

      return domain;
    },
    isValidDomain(domain: string): boolean {
      return /^[a-z0-9.-]+\.[a-z]{2,}$/.test(domain);
    },
    onDomainBlur() {
      const normalized = this.normalizeDomain(this.localIntegration.domain);

      if (this.isValidDomain(normalized)) {
        this.localIntegration.domain = normalized;
      }
    }
  },
  computed: {
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  },
  watch: {
    integration: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) return;

        this.localIntegration = {
          domain: newVal || ""
        };
      }
    }
  }
});
</script>
